<fieldset>
  <!-- <span class="operator-title tw-text-gray-500 sm:tw-mx-4 tw-font-bold tw-mx-1 sm:tw-block tw-hidden">{{
    "common.operator" |
    translate }}
    <span class="tw-mr-[5px] ltr:tw-ml-[5px] tw-text-gray-500">*</span>
  </span> -->
  <legend>
    {{ "common.operator" | translate }}
  </legend>

  <div class="tw-flex-center tw-mb-2">
    <!-- MCI -->
    <ng-container *ngIf="isExistsMCI">
      <div
        class="tw-relative tw-flex-center tw-border tw-border-[#e0e0e0] dark:tw-border-dark-100 tw-rounded-[5px] tw-py-2 tw-h-[50px] tw-cursor-pointer"
        [ngClass]="
          (selectedOperator == SmsAggregator.MCI && isShowToggle) ||
          (selectedOperator == SmsAggregator.MCI && isDetailMode)
            ? 'tw-bg-gray-300 dark:tw-bg-dark-200'
            : 'tw-bg-[#fbfbfb] dark:tw-bg-dark-600'
        "
        style="flex: 1"
      >
        <!-- has toggle -->
        <mat-slide-toggle
          *ngIf="isShowToggle"
          [class]="'mci-'"
          [attr.data-sms-aggregator]="SmsAggregator.MCI"
        >
          <div
            class="tw-flex sm:tw-flex-row tw-flex-col tw-items-center tw-justify-center"
          >
            <img
              class="sm:tw-block tw-hidden dark:tw-contrast-50"
              [smsAggregatorImage]="'MCI'"
              [smsAggregatorImageWidth]="'MCI'"
            />
            <span class="tw-mt-1 tw-mr-2 sm:tw-text-lg tw-text-sm text-dark">{{
              "common.mci" | translate
            }}</span>
          </div>
        </mat-slide-toggle>

        <!-- has not toggle -->
        <div
          *ngIf="!isShowToggle"
          class="tw-flex sm:tw-flex-row tw-flex-col tw-items-center tw-justify-center"
        >
          <img
            class="sm:tw-block tw-hidden dark:tw-contrast-50"
            [smsAggregatorImage]="'MCI'"
            [smsAggregatorImageWidth]="'MCI'"
          />
          <span class="tw-mt-1 tw-mr-2 sm:tw-text-lg tw-text-sm text-dark">{{
            "common.mci" | translate
          }}</span>
        </div>

        <div
          class="tw-absolute tw-left-0 tw-right-0 tw-top-0 tw-bottom-0 tw-z-[5]"
          (click)="selectOperatorChecked('.mci-', SmsAggregator.MCI)"
        ></div>
      </div>
    </ng-container>

    <!-- irancell -->
    <ng-container *ngIf="isExistsIrancell">
      <div
        class="tw-relative tw-flex-center tw-border tw-border-[#e0e0e0] dark:tw-border-dark-100 tw-rounded-[5px] tw-cursor-pointer tw-py-2 tw-h-[50px] tw-mx-2"
        [ngClass]="
          (selectedOperator == SmsAggregator.Irancell && isShowToggle) ||
          (selectedOperator == SmsAggregator.Irancell && isDetailMode)
            ? 'tw-bg-gray-300 dark:tw-bg-dark-200'
            : 'tw-bg-[#fbfbfb] dark:tw-bg-dark-600'
        "
        style="flex: 1"
      >
        <!-- has toggle -->
        <mat-slide-toggle
          *ngIf="isShowToggle"
          [class]="'irancell-'"
          [attr.data-sms-aggregator]="SmsAggregator.Irancell"
        >
          <div
            class="tw-flex sm:tw-flex-row tw-flex-col tw-items-center tw-justify-center"
          >
            <img
              class="sm:tw-block tw-hidden"
              [smsAggregatorImage]="'Irancell'"
              [smsAggregatorImageWidth]="'Irancell'"
            />
            <span class="tw-mt-1 tw-mr-2 sm:tw-text-lg tw-text-sm text-dark">{{
              "common.mtn" | translate
            }}</span>
          </div>
        </mat-slide-toggle>

        <!-- has not toggle -->
        <div
          *ngIf="!isShowToggle"
          class="tw-flex sm:tw-flex-row tw-flex-col tw-items-center tw-justify-center"
        >
          <img
            class="sm:tw-block tw-hidden"
            [smsAggregatorImage]="'Irancell'"
            [smsAggregatorImageWidth]="'Irancell'"
          />
          <span class="tw-mt-1 tw-mr-2 sm:tw-text-lg tw-text-sm text-dark">{{
            "common.mtn" | translate
          }}</span>
        </div>

        <div
          *ngIf="isShowToggle || isDetailMode"
          class="tw-absolute tw-left-0 tw-right-0 tw-top-0 tw-bottom-0 tw-z-[5]"
          (click)="selectOperatorChecked('.irancell-', SmsAggregator.Irancell)"
        ></div>
      </div>
    </ng-container>

    <!-- rightel -->
    <ng-container *ngIf="isExistsRightel">
      <div
        class="tw-relative tw-flex-center tw-border tw-border-[#e0e0e0] dark:tw-border-dark-100 tw-cursor-pointer tw-rounded-[5px] tw-py-2 tw-h-[50px]"
        [ngClass]="
          (selectedOperator == SmsAggregator.Rightel && isShowToggle) ||
          (selectedOperator == SmsAggregator.Rightel && isDetailMode)
            ? 'tw-bg-gray-300 dark:tw-bg-dark-200'
            : 'tw-bg-[#fbfbfb] dark:tw-bg-dark-600'
        "
        style="flex: 1"
      >
        <!-- has toggle -->
        <mat-slide-toggle
          *ngIf="isShowToggle"
          [class]="'rightel-'"
          [attr.data-sms-aggregator]="SmsAggregator.Rightel"
        >
          <div
            class="tw-flex sm:tw-flex-row tw-flex-col tw-items-center tw-justify-center"
          >
            <img
              class="sm:tw-block tw-hidden"
              [smsAggregatorImage]="'Rightel'"
              [smsAggregatorImageWidth]="'Rightel'"
            />
            <span class="tw-mt-1 tw-mr-2 sm:tw-text-lg tw-text-sm text-dark">{{
              "common.rightel" | translate
            }}</span>
          </div>
        </mat-slide-toggle>

        <!-- has not toggle -->
        <div
          *ngIf="!isShowToggle"
          class="tw-flex sm:tw-flex-row tw-flex-col tw-items-center tw-justify-center"
        >
          <img
            class="sm:tw-block tw-hidden"
            [smsAggregatorImage]="'Rightel'"
            [smsAggregatorImageWidth]="'Rightel'"
          />
          <span class="tw-mt-1 tw-mr-2 sm:tw-text-lg tw-text-sm text-dark">{{
            "common.rightel" | translate
          }}</span>
        </div>

        <div
          *ngIf="isShowToggle || isDetailMode"
          class="tw-absolute tw-left-0 tw-right-0 tw-top-0 tw-bottom-0 tw-z-[5]"
          (click)="selectOperatorChecked('.rightel-', SmsAggregator.Rightel)"
        ></div>
      </div>
    </ng-container>
  </div>

  <div
    class="row tw-mb-2"
    *ngIf="!isExistsMCI && !isExistsIrancell && !isExistsRightel"
  >
    <div class="title-preloading bg-preloading sm:tw-mx-1"></div>
    <div class="title-preloading bg-preloading tw-mx-1"></div>
    <div class="title-preloading bg-preloading sm:tw-mx-1"></div>
  </div>
</fieldset>
